import React from "react";
import "./detailListLayout.css";

/**
 * 상세/등록 공통 본문 래퍼. isEditing 시 폼 컨트롤 스타일용 클래스 부여.
 */
export function DetailListPage({isEditing = false, className = "", children}) {
    const pageClass = `detail-list-page asset-detail-list-page${isEditing ? " is-editing" : ""}`;
    return <div className={`${pageClass} ${className}`.trim()}>{children}</div>;
}
